import React from 'react';
import styles from './LinkList.module.scss';
import { LinkListElementProps } from './LinkListElement/LinkListElement';

export interface LinkListProps {
  className?: string;
  children:
    | React.ReactElement<LinkListElementProps>
    | React.ReactElement<LinkListElementProps>[];
}

export const LinkList = ({
  className = '',
  children
}: LinkListProps): React.ReactElement<LinkListProps> => {
  return <ul className={`${styles.linkList} ${className}`}>{children}</ul>;
};
